import { flow, Instance, types } from 'mobx-state-tree';
import { getEnvironment } from './utils';
import { getBaseStore } from './BaseStore';
import { Planner } from './models/Planner';
import { values } from 'lodash';
import SecretariatDashboard from '../components/SecretariatDashboard';

export const PlannerStore = types
  .compose(
    getBaseStore<Instance<typeof Planner>, Instance<typeof Planner>>(Planner, 'PlannerId', 'planner'),
    types.model('PlannerStore', {
      firstDate: '',
      startDate: '',
      lastDate: '',
      rules: '',
    }),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        const planner = self.datas.get(id.toString());
        if (planner) {
          return planner;
        } else {
          return {
            plannerId: 1,
          };
        }
      } else {
        return {
          plannerId: 1,
        };
      }
    },
  }))
  .actions((self: any) => {
    const env = getEnvironment(self);
    // const root: RootStoreType = getRoot(self);
    const plannerApiFetcher = env.plannerApi;

    const startPlanner = flow(function*(data: any) {
      self.firstDate = data.firstDate;
      self.startDate = data.startDate;
      self.lastDate = data.lastDate;
      const result = yield env.plannerApi.post('start', data);
      if (result != null) {
        const planner = self.getByIdOrNew(-1);
        planner.status = result;
        if (!planner.status.currentBestScore) {
          planner.status.currentBestScore = {};
        }
        planner.startDate = planner.status.startDD;
        planner.endDate = planner.status.lastDD;
        self.datas.put(planner);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });
    const suspendPlanner = flow(function*(data: any) {
      const result = yield env.plannerApi.post('stop', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.status = result;
        if (!planner.status.currentBestScore) {
          planner.status.currentBestScore = {};
        }
        console.log(result);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });
    const resumePlanner = flow(function*(data: any) {
      const result = yield env.plannerApi.post('resume', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.status = result;
        if (!planner.status.currentBestScore) {
          planner.status.currentBestScore = {};
        }
        planner.startDate = planner.status.startDD;
        planner.endDate = planner.status.lastDD;
        self.datas.put(planner);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });
    const stopPlanner = flow(function*(data: any) {
      const result = yield env.plannerApi.post('stop', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.status = result;
        if (!planner.status.currentBestScore) {
          planner.status.currentBestScore = {};
        }
        planner.startDate = planner.status.startDD;
        planner.endDate = planner.status.lastDD;
        self.datas.put(planner);
        console.log(result);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });
    const getStatus = flow(function*(data: any) {
      const result = yield env.plannerApi.get('status', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        // result.startedOn = result.startDD;
        planner.status = result;
        if (!planner.status.currentBestScore) {
          planner.status.currentBestScore = { value: '' };
        }
        planner.startDate = planner.status.startDD;
        planner.endDate = planner.status.lastDD;
        // planner.status.startedOn = planner.status.startDD;
        self.datas.put(planner);
        // self.datas.put(planner);
        self.firstDate = planner.status.firstDD;
        self.startDate = planner.status.startDD;
        self.lastDate = planner.status.lastDD;
        console.log(result);
      }
      // NotificationToast.showSuccess('Got status');
    });

    const getRules = flow(function*(data: any) {
      const result = yield env.api.get('Planning/getRules/byPlanning/' + data.PlanningId);
      if (result != null) {
        self.rules = result;
      }
    });

    const saveDutyAssignments = flow(function*(data: any) {
      const result = yield env.plannerApi.post('solution/dutyAssignments', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.return = result;
        console.log(result);
      }
    });
    const publishPlanning = flow(function*(data: any) {
      const result = yield env.api.post('Planning/publish/first/' + data.firstDate + '/last/' + data.lastDate, null);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.return = result;
      }
    });
    const downloadPlanning = flow(function*(data: any) {
      const filesToDownload = yield env.api.get('Planning/assignments/download/from/to', {
        params: {
          fileLinesLimit: data.fileLinesLimit,
          from: data.from,
          to: data.to,
          secretariatId: data.secretariatId,
        },
      });
      if (filesToDownload != null) {
        const filePaths = filesToDownload as Array<string>;
        filePaths.forEach((element) => {
          downloadPlanningFile(element);
        });
      }
    });

    const downloadPlanningFile = flow(function*(data: string) {
      const result = yield env.api.get('Planning/assignments/download', {
        params: { responseType: 'blob', filePath: data },
      });
      if (result != null) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'PharmagardeToWebGardePlanning-' + new Date().toISOString() + '.csv'); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    });

    const replicateLevel1DutyAssignments = flow(function*(data: any) {
      const result = yield env.api.post(
        'Planning/assignments/replicate/first/' + data.startDate + '/last/' + data.lastDate,
        null,
      );
    });

    const getPlanning = flow(function*(data: any) {
      const result = yield env.api.get('Planning/latest');
      if (result != null) {
        console.log(result);
      }
    });

    const importPharmacy = flow(function*(data: any) {
      const result = yield env.api.get('Planning/ImportPharmacyFromApb/' + data);
      // if (result != null) {
      //   console.log(result);
      // }
    });

    const getConstraintMatchTotal = flow(function*(data: any) {
      const result = yield env.plannerApi.get('solution/constraintMatchTotal', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.matchList = (result as string[]).concat();
        self.datas.put(planner);
        // console.log(result);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });

    const getScoreExplanation = flow(function*(data: any) {
      const result = yield env.plannerApi.get('solution/scoreExplanation', data);
      if (result != null) {
        // self.explanation = result;
        const planner = self.getByIdOrNew(1);
        planner.explanation = (result as string[]).concat();
        self.datas.put(planner);      }
    });

    const getIndictmentMap = flow(function*(data: any) {
      // const result = yield env.plannerApi.get('solution/indictmentMap', data);
      const result = yield env.plannerApi.get('solution/scoreExplanation', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.indictmentList = (result as string[]).concat();
        self.datas.put(planner);
        // console.log(result);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });

    const getScores = flow(function*(data: any) {
      const result = yield env.plannerApi.post('solution/scoreList', data);
      if (result != null) {
        const planner = self.getByIdOrNew(1);
        planner.scoreList = (result as number[]).concat();
        self.datas.put(planner);
      }
    });

    const getScoresByRunId = flow(function*(data: any) {
      const result = yield env.api.get('Planning/getScoreList/' + data, {});
      // const result = yield env.plannerApi.post('solution/scoreList', data);
      if (result != null) {
        // const res = (result as number[]).concat();
        // let list = new Array();
        // let i=0;
        // res.forEach((value) => {
        //   list.push({ key: i, value: value });
        //   i += 1;
        // });
        // return list;
        let list = new Array();
        Object.keys(result).map((key) => {
          list.push({ key: key, value: result![key] });
        });
        return list;
      }
      return null;
    });

    const serializeSolution = flow(function*(data: any) {
      const result = yield env.plannerApi.get('solution/serialize', data);
      if (result != null) {
        console.log(result);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });

    const fullSaveSolution = flow(function*(data: any) {
      const result = yield env.plannerApi.get('solution/fullSave', data);
      if (result != null) {
        console.log(result);
      }
      // NotificationToast.showSuccess('Data saved successfully');
    });

    const reloadSolution = flow(function*(data: any) {
      const result = yield env.plannerApi.get('solution/reload', data);
      // if (result != null) {
      //   console.log(result);
      // }
      // NotificationToast.showSuccess('Data saved successfully');
    });

    const uploadAssignmentFile = flow(function*(data: any) {
      env.api.postFile('Planning/assignments/upload', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    });

    const uploadAssignments = flow(function*(data: string) {
      yield env.api.post('Planning/assignments/upload2', data);
    });

    const uploadFile = flow(function*(data: File) {
      const dt = new FormData();
      dt.append('file', data, data.name);
      const settings = { headers: { 'Content-Type': undefined } };
      const res = yield env.api.postFile('Planning/assignments/upload', dt, settings);
      return res;
    });

    const initializeHangfire = flow(function*() {
      yield env.api.post('Planning/InitializeHangfire', null);
    });

    const downloadAdjacentPharmacyData = flow(function*() {
      yield env.api.post('Planning/DownloadAdjacentPharmacyData', null);
    });

    const copyBPOrDuties = flow(function*(type: string, semester: string, yearFrom: string, yearTo: string) {
      if (type === 'bp') {
        yield env.api.post(
          'Planning/CopyBP/semester/' + semester + '/yearFrom/' + yearFrom + '/yearTo/' + yearTo,
          null,
        );
      } else if (type === 'duties') {
        yield env.api.post(
          'Planning/CopyDuties/semester/' + semester + '/yearFrom/' + yearFrom + '/yearTo/' + yearTo,
          null,
        );
      }
    });

    return {
      startPlanner,
      downloadPlanning,
      suspendPlanner,
      resumePlanner,
      stopPlanner,
      getStatus,
      getRules,
      // getScores,
      getScoreExplanation,
      saveDutyAssignments,
      publishPlanning,
      serializeSolution,
      fullSaveSolution,
      reloadSolution,
      // explainScore,
      getConstraintMatchTotal,
      getIndictmentMap,
      getScores,
      getScoresByRunId,
      uploadAssignmentFile,
      uploadAssignments,
      uploadFile,
      initializeHangfire,
      downloadAdjacentPharmacyData,
      importPharmacy,
      replicateLevel1DutyAssignments,
      copyBPOrDuties,
    };
  });

export type PlannerStoreType = typeof PlannerStore.Type;
